import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=344e945a&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=ts"
export * from "./ImageCarousel.vue?vue&type=script&lang=ts"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&id=344e945a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344e945a",
  null
  
)

export default component.exports